var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCmsSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5546 7.17603C14.0746 7.17603 13.6426 7.22403 13.2346 7.36803C13.7386 7.77603 14.1706 8.28003 14.5306 8.83203H14.5546C16.2346 8.83203 17.6026 10.2 17.6026 11.88C17.6026 13.56 16.2346 14.928 14.5546 14.928C14.1466 14.928 13.7146 14.856 13.3546 14.688C13.5706 14.376 13.7626 14.04 13.9066 13.728C13.9546 13.584 14.0266 13.488 14.0506 13.344C14.1946 12.912 14.2666 12.408 14.2666 11.904C14.2666 9.31203 12.1546 7.20003 9.56264 7.20003C6.97064 7.20003 4.85864 9.28803 4.85864 11.88C4.85864 14.472 6.97064 16.584 9.56264 16.584C10.0426 16.584 10.4746 16.536 10.8826 16.392C10.3786 15.984 9.94664 15.48 9.58664 14.928H9.56264C7.88264 14.928 6.51464 13.56 6.51464 11.88C6.51464 10.2 7.88264 8.83203 9.56264 8.83203C9.97064 8.83203 10.4026 8.90403 10.7866 9.07203C10.2106 9.84003 9.85064 10.824 9.85064 11.88C9.85064 14.472 11.9626 16.584 14.5546 16.584C17.1466 16.584 19.2586 14.472 19.2586 11.88C19.2586 9.28803 17.1466 7.17603 14.5546 7.17603Z",
    fill: "#5D2EDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmsSvgrepoCom1);
export default __webpack_public_path__ + "static/media/cms-svgrepo-com 1.db91e9ca222504b70e2b33f9aa56b293.svg";
export { ForwardRef as ReactComponent };